import { Container } from 'src/components/common/Container'
import { ZIndex } from 'src/styles/mixin'
import styled from 'styled-components'

const textLogo = `${process.env.PUBLIC_URL}/images/text_logo.svg`

const PreviewHeader = () => {
  return (
    <S.PreviewHeaderWrap>
      <S.TextLogoImage src={textLogo} alt="logo" />
    </S.PreviewHeaderWrap>
  )
}

export default PreviewHeader

const S = {
  PreviewHeaderWrap: styled(Container)`
    position: fixed;
    top: 0;
    display: flex;
    justify-content: center;
    padding: 6px 20px;
    max-width: 688px;
    min-width: 320px;
    width: 100%;
    height: 50px;
    background: var(--white);
    z-index: ${ZIndex.TopMenu};
  `,
  TextLogoImage: styled.img``,
}
